import { c as _c } from "react/compiler-runtime";
import Container from "../wrapper/Container";
import SectionSubHeading from "../common/titles/SectionSubHeading";
import SectionTitle from "../common/titles/SectionTitle";
import TestimonialCard from "../common/cards/TestimonialCard";
import { testimonialData } from "@/data/TestimonialData";
const Testimonials = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SectionSubHeading subtitle="Clients Reactions" className="text-white" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-2">{t0}<SectionTitle title={<>SUCCESS STORIES <br /> FROM OUR PARTNERS.</>} className="text-white" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="bg-accent-foreground lg:pb-20 pb-8 lg:pt-24 pt-16 rounded-b-4xl"><Container className="px-4 lg:px-10 flex flex-col gap-10">{t1}<div className="w-full relative rounded-b-4xl overflow-hidden"><TestimonialCard data={testimonialData} /></div></Container></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Testimonials;